import { render, staticRenderFns } from "./ConsumptionNotifications.vue?vue&type=template&id=5f6610c0&scoped=true&"
import script from "./ConsumptionNotifications.vue?vue&type=script&lang=js&"
export * from "./ConsumptionNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionNotifications.vue?vue&type=style&index=0&id=5f6610c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6610c0",
  null
  
)

export default component.exports